export const BORDER_RADIUS = [
  0,
  4,
  8
]
